<template>
  <div class="buyer_wrap">
    <el-container class="container">
      <div style="width: 100%">
        <el-main style="padding:20px 0;">
          <el-container>
            <el-main style="padding:0 0 20px 20px;">
              <!-- 主要内容右侧start -->
              <div class="buyer_view_right">
                <!-- 用户信息start-->
                <div class="user_info box">
                  <div class="hot_top" v-if="info" v-cloak>
                    <div class="top_img">
                      <img :src="info.headPath" v-if="info && info.headPath" />
                      <img v-else src="https://sctcc-applet.oss-cn-shenzhen.aliyuncs.com/hz_space_star/img/default.png" />
                    </div>
                    <div class="top_text">
                      <p>欢迎您</p>
                      <div class="text_username">
                        <span>{{info.user_name }}</span>
                        <el-tooltip
                          v-if="auth"
                          class="item"
                          effect="dark"
                          content="已认证"
                          placement="top-start"
                        >
                          <i class="icon certified" style="color:#23E455;"></i>
                        </el-tooltip>
                        <el-tooltip
                          v-else
                          class="item"
                          content="未认证"
                          placement="top-start"
                          popper-class="authentication"
                        >
                          <router-link
                            to="/personal_center/enterprise/enterprise_certification/enterprise_certificaiton_table_list"
                          >
                            <i class="icon uncertified"></i>
                          </router-link>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                  <div class="hot_bottom" v-if="info" v-cloak>
                    <div>
                      <i class="icon company"></i>
                      <span>{{(authPark && authPark.extend3 ) || "暂无企业信息"}}</span>
                    </div>
                  </div>
                </div>
                <!-- 用户信息end-->

                <!-- 订单动态start -->
                <div class="order_dynamic box mt20">
                  <!-- 订单动态标题 -->
                  <div class="order_dynamic_title">
                    <span class="dynamic_title_left">订单动态</span>
                    <span class="dynamic_title_right">
                      <router-link to="/personal_center/service_provider/service_provider_order">
                        更多
                        <i class="el-icon-arrow-right"></i>
                      </router-link>
                    </span>
                  </div>
                  <el-table :data="tableObj.list" border style="width: 100%" class="mt20">
                    <el-table-column prop="code" label="订单号"></el-table-column>
                    <el-table-column prop="name" label="商品名称"></el-table-column>
                    <el-table-column prop="incubator_name" label="订单园区" width="120"></el-table-column>
                    <el-table-column prop="create_date" label="下单时间" width="120"></el-table-column>
                    <el-table-column prop="co_user_name" label="买家单位名称" width="120"></el-table-column>
                    <el-table-column prop="contact" label="买家姓名" width="120"></el-table-column>
                    <el-table-column prop="status_name" label="状态" width="120"></el-table-column>
<!--                    <el-table-column fixed="right" label="操作" width="100">-->
<!--                      <template slot-scope="scope">-->
<!--                        &lt;!&ndash;待接单  &ndash;&gt;-->
<!--                        <div class="center" v-if="scope.row.status==='ServiceOrderStatusWait'">-->
<!--                          <div>-->
<!--                            <div class="blue_btn" @click="btnClick('detail',scope.row)">详情</div>-->
<!--                          </div>-->
<!--                          <div>-->
<!--                            <div class="blue_btn" @click="btnClick('order',scope.row)">接单</div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;  已完成 &ndash;&gt;-->
<!--                        <div class="center" v-if="scope.row.status==='ServiceOrderStatusComplete'">-->
<!--                          <div>-->
<!--                            <div class="blue_btn" @click="btnClick('detail',scope.row)">详情</div>-->
<!--                          </div>-->
<!--                          <div>-->
<!--                            <div class="blue_btn" @click="btnClick('showRemark',scope.row)">完成情况</div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                        &lt;!&ndash; 已接单 &ndash;&gt;-->
<!--                        <div class="center" v-else-if="scope.row.status==='ServiceOrderStatusAccept'">-->
<!--                          <div>-->
<!--                            <div class="blue_btn" @click="btnClick('detail',scope.row)">详情</div>-->
<!--                          </div>-->
<!--                          <div>-->
<!--                            <div class="blue_btn" @click="btnClick('complete',scope.row)">完成</div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </template>-->
<!--                    </el-table-column>-->
                  </el-table>
                  <!-- 订单动态类型 -->
<!--                  <div class="order_dynamic_type">-->
<!--                    <div class="type_left">-->
<!--                      <span>订单详情</span>-->
<!--                    </div>-->
<!--                    <div class="type_right">-->
<!--                      <span>店铺名称</span>-->
<!--                      <span>价格</span>-->
<!--                      <span>预计价格</span>-->
<!--                      <span>下单时间</span>-->
<!--                      <span>订单状态</span>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  &lt;!&ndash; 每个订单 &ndash;&gt;-->
<!--                  <div v-if="tableObj.list.length">-->
<!--                    <div v-for="(item,index) in tableObj.list" :key="index">-->
<!--                      <div v-if="item">-->
<!--                        <div class="order_dynamic_orderNumber">-->
<!--                          <div class="order_left">-->
<!--                            <span>订单号：</span>-->
<!--                            <span>{{item.code}}</span>-->
<!--                          </div>-->
<!--                          <div class="order_right">-->
<!--                            <span>下单时间：</span>-->
<!--                            <span>{{item.create_date}}</span>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                        <div class="order_dynamic_content">-->
<!--                          &lt;!&ndash; 订单详情 &ndash;&gt;-->
<!--                          <div class="product_name">-->
<!--                            <div class="product_name_l">-->
<!--                              <img :src="item.coverPath" alt />-->
<!--                            </div>-->
<!--                            <div class="product_name_r">-->
<!--                              &lt;!&ndash; <router-link to="/supermarket/shop_detail?id='+item.id'"> &ndash;&gt;-->
<!--                              {{item.name}}-->
<!--                              &lt;!&ndash; </router-link> &ndash;&gt;-->
<!--                            </div>-->
<!--                          </div>-->
<!--                          &lt;!&ndash; 店铺名称 &ndash;&gt;-->
<!--                          <div class="business_type">{{item.shop_name}}</div>-->
<!--                          &lt;!&ndash; 价格 &ndash;&gt;-->
<!--                          <div class="buy_name">-->
<!--                            <span>{{item.price}}</span>-->
<!--                          </div>-->
<!--                          &lt;!&ndash; 预计价格 &ndash;&gt;-->
<!--                          <div class="buy_phone">{{item.service_price}}</div>-->
<!--                          &lt;!&ndash; 下单时间 &ndash;&gt;-->
<!--                          <div class="order_status">{{item.create_date}}</div>-->
<!--                          &lt;!&ndash; 订单状态 &ndash;&gt;-->
<!--                          <div class="operation">{{item.status_name}}</div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div v-else class="no_data">暂无数据</div>-->
                </div>
                <!-- 订单动态end -->

                <!-- 园区通告 -->
<!--                <div class="recently_browse">-->
<!--                  <template>-->
<!--                    <div class="browse_title_wrap">-->
<!--                      <div class="title_wrap_left">园区通告</div>-->
<!--                      <div class="title_wrap_right">-->
<!--                        <router-link-->
<!--                          to="/personal_center/park_user/park_notice/notice_list"-->
<!--                          class="more-link"-->
<!--                        >-->
<!--                          更多-->
<!--                          <i class="el-icon-arrow-right"></i>-->
<!--                        </router-link>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="browse_content" v-if="park_notice.length" v-cloak>-->
<!--                      <div-->
<!--                        class="rb_content_model"-->
<!--                        v-for="item in park_notice"-->
<!--                        :key="item.id"-->
<!--                        @click="toNoticeDetail(item.id)"-->
<!--                      >-->
<!--                        <div class="rb_content_model_top">-->
<!--                          <img v-lazy="item.coverPath" />-->
<!--                        </div>-->
<!--                        <div class="rb_content_model_bottom">-->
<!--                          <div class="model_bottom_top ellip">{{ item.name }}</div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <p-->
<!--                      v-else-->
<!--                      style="font-size:18px;color:#999999;text-align:center;line-height:80px;"-->
<!--                    >暂无通告</p>-->
<!--                  </template>-->
<!--                </div>-->
              </div>
              <!-- 主要内容右侧end -->
            </el-main>
          </el-container>
        </el-main>
      </div>
    </el-container>
  </div>
</template>
<script>
import myTable from "@/components/my_table.vue";
import { mapActions,mapState } from 'vuex'
export default {
  components: {
    myTable
  },
  data() {
    return {
      auth: null,
      curActive: "",
      tableData: [], //订单动态
      centerDialogVisible: false, //评价弹窗
      tableObj: {
        list: [] //列表数据
      },
      tableObj2: {
        form: {
          //订单评价
          anonymous: false,
          content: "",
          grade: 0, //商品评分星星等级
          score_major: 0, //专业评分星星等级
          score_service: 0, //服务评分星星等级
          score_speed: 0, //速度评分星星等级
          row: {}
        }
      },
      park_notice: [], //园区通告
      certificationType: "CertificationTypeInnovate" //传入买家身份
    };
  },
  computed: {
    ...mapState('service_provider', {
      authPark: state => state.authPark
    }),
    info() {
      return this.$store.state.info;
    },
    company() {
      return this.$store.state.company;
    },
    parkInfo() {
      return this.$store.state.parkInfo;
    }
  },
  created() {
    if (this.info) {
      // console.log(this.company);
      this.getAsyncData();
    } else {
      this.needInfo("getAsyncData");
    }
  },
  methods: {
    /* 监测个人信息 */
    needInfo(fn) {
      // console.log(fn);
      let watchAch = this.$watch("info", (val, oldVal) => {
        if (val) {
          // console.log(val);
          this[fn]();
          watchAch(); //取消监听
        }
      });
    },
    async getAsyncData(){
      await this.getEnterprises();
      await this.getOrders();
    },
    // 查询服务商入驻情况
    getEnterprises() {
      let params = Object.assign({}, {
        type: "StarryExtendTypeBService",
        user_id: this.info.id,
        status: 'IdentityCertifieStatussuccess'
      });
      return this.api.getExtends(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        let obj = res.obj.list[0] || null;
        this.auth = obj;
      });
    },
    /* 订单查询 */
    getOrders() {
      let params = Object.assign({},this.searchObj,{
        loginKey: sessionStorage.getItem('loginKey'),
        user_sale_id: this.info.id,
        type: 'ServiceTypeFNService',
        certificationType: 'CertificationTypeInnovate',
        sort: "SortTimeDESC", //时间降序
        pageSize: 5,
        incubator: this.authPark ? this.authPark.incubator : ''
      })
      this.api.getFNOrders(params).then(res=>{
        if(res.error['err_code'] !== 0) return;
        this.tableObj.list = res.obj.list;
      })
    },
    //热门通告查询
    getHotNews() {
      this.api
        .getNews({
          type: "ActiveTypeParkNotice",
          incubator: this.parkInfo.id,
          pageSize: 4,
          pageNo: 0
        })
        .then(res => {
          console.log(res);
          if (res.error.err_code !== 0) return;
          let list = res.obj.list;
          this.park_notice = list.length ? list : [];
        });
    },
    /** 页码改变
     * @params obj.val 当前页码
     * @params obj.tableName 表格名称*/
    changePageNo(obj) {
      console.log(obj);
      this.tableObj.layerpageinfo.pageNo = obj.val;
      this.getPatents();
    },
    btnclick() {},
    //点击热门通告进入通告详情
    toNoticeDetail(id) {
      this.$router.push({
        name: "notice_detail",
        id: id
      });
    }
  },
  watch: {
    $route(to, form) {
      this.curActive2();
    }
  }
};
</script>

<style lang="scss">
  @import "../../index.scss";
  .buyer_wrap {
    height: 100%;
    background-color: #f5f5f5;
    // 主要内容右侧start
    .buyer_view_right {
      padding-top: -30px;

      .box{
        border-radius: 6px;
        padding-bottom: 10px;
      }
      // 用户信息start
      .user_info {
        background-color: #fff;
        .hot_top {
          display: flex;
          border-bottom: 1px solid #e5e8ed;
          padding: 30px 0px 20px 20px;
          .top_img {
            width: 80px;
            height: 80px;
            background: rgba(242, 106, 247, 0.2);
            border-radius: 50%;
            overflow: hidden;
            margin-right: 20px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .top_text {
            padding-top: 10px;
            p {
              font-size: 14px;
              line-height: 30px;
              color: #4b5062;
            }
            .text_username {
              span {
                font-size: 18px;
                line-height: 36px;
                font-weight: bold;
                color: #4b5062;
                padding-right: 13px;
              }
              .authentication {
                background: #999999 !important;
              }
              i {
                font-size: 18px;
                line-height: 36px;
                cursor: pointer;
              }
              .gray {
                color: #999;
              }
            }
          }
        }
        .icon {
          width: 18px;
          height: 18px;
          display: inline-block;
          vertical-align: text-bottom;
        }
        .company {
          width: 15px;
          background-image: url("../../../../assets/img/icon/company.png");
        }
        .uncertified {
          background-image: url("../../../../assets/img/icon/uncertified.png");
        }
        .certified {
          background-image: url("../../../../assets/img/icon/certified.png");
        }
        .hot_bottom {
          padding: 10px 0 10px 20px;
          div {
            span {
              font-size: 14px;
              line-height: 38px;
              font-weight: 400;
              color: #4b5062;
            }
            i {
              color: #ff733c;
              margin-right: 12px;
            }
            .bottom_integral {
              font-size: 16px;
              color: #4b5062;
              font-weight: Bold;
            }
          }
        }
      }
      // 用户信息end

      // 订单动态
      .order_dynamic {
        background-color: #fff;
        padding: 0 20px 20px;
        margin-top: 20px;
        // 订单动态标题
        .order_dynamic_title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 60px;
          background-color: #fff;
          border-bottom: 1px solid #ebeef5;
          color: #909399;
          .dynamic_title_left {
            font-size: 18px;
            line-height: 58px;
            font-weight: bold;
            color: #4b5062;
          }
          .dynamic_title_right {
            a {
              color: #4b5062;
            }
          }
        }
        // 订单动态类型
        .order_dynamic_type {
          display: flex;
          height: 44px;
          line-height: 44px;
          background-color: #f5f6fa;
          margin-bottom: 20px;
          font-size: 14px;
          font-weight: 400;
          color: #4b5062;
          .type_left {
            width: 306px;
            span {
              padding-left: 18px;
            }
          }
          .type_right {
            flex: 1;
            span {
              display: inline-block;
              width: 126px;
              text-align: center;
            }
          }
        }
        // 订单动态订单号
        .order_dynamic_orderNumber {
          display: flex;
          height: 44px;
          line-height: 44px;
          background-color: #f5f6fa;
          font-size: 14px;
          font-weight: 400;
          color: #9ea2b3;
          margin-top: 20px;
          .order_left {
            margin-right: 55px;
            padding-left: 18px;
          }
          .order_right {
          }
        }
        // 订单动态内容
        .order_dynamic_content {
          display: flex;
          border-top: 1px solid #e5e8ed;
          border-bottom: 1px solid #e5e8ed;
          font-size: 14px;
          line-height: 24px;
          // 商品名称
          .product_name {
            display: flex;
            width: 306px;
            box-sizing: border-box;
            border-left: 1px solid #e5e8ed;
            border-right: 1px solid #e5e8ed;
            padding: 20px 20px 20px 20px;
            .product_name_l {
              width: 80px;
              height: 80px;
              background-color: #ccc;
              img {
                display: block;
                width: 100%;
                height: 100%;
              }
            }
            .product_name_r {
              padding-left: 13px;
              flex: 1;
              word-break: break-all;
              a {
                color: #3282ff;
              }
            }
          }
          // 业务类型
          .business_type {
            width: 126px;
            text-align: center;
            overflow: hidden;
            border-right: 1px solid #e5e8ed;
            word-break: break-all;
            line-height: 23px;
            box-sizing: border-box;
            padding: 30px 10px 10px 10px;
          }
          // 买家姓名
          .buy_name {
            width: 126px;
            text-align: center;
            overflow: hidden;
            border-right: 1px solid #e5e8ed;
            box-sizing: border-box;
            word-break: break-all;
            line-height: 23px;
            box-sizing: border-box;
            padding: 30px 10px 10px 10px;
          }
          // 买家电话
          .buy_phone {
            width: 126px;
            text-align: center;
            overflow: hidden;
            border-right: 1px solid #e5e8ed;
            word-break: break-all;
            line-height: 23px;
            box-sizing: border-box;
            padding: 30px 10px 10px 10px;
          }
          // 订单状态
          .order_status {
            width: 126px;
            text-align: center;
            overflow: hidden;
            border-right: 1px solid #e5e8ed;
            word-break: break-all;
            line-height: 23px;
            box-sizing: border-box;
            padding: 30px 10px 10px 10px;
          }
          // 操作
          .operation {
            width: 126px;
            text-align: center;
            overflow: hidden;
            border-right: 1px solid #e5e8ed;
            word-break: break-all;
            line-height: 23px;
            box-sizing: border-box;
            padding: 30px 10px 10px 10px;
            a {
              color: #3282ff;
            }
            div:first-child {
              padding-bottom: 9px;
            }
          }
        }
        .no_data {
          text-align: center;
          font-size: 18px;
          line-height: 35px;
          color: #999;
        }
      }

      // 最近浏览
      .recently_browse {
        margin-top: 20px;
        // height: 322px;
        background-color: #fff;
        // 最近浏览的标题
        .browse_title {
        }
        // 最近浏览的主体内容
        .browse_content {
          display: flex;
          padding: 0 20px;
          /*justify-content: space-around;*/
          //  最近浏览的每个模块
          .rb_content_model:hover {
            background: rgba(255, 255, 255, 1);
            box-shadow: 0 0 10px 2px rgba(234, 237, 241, 1);
          }
          .item-link {
            display: flex;
            width: 100%;
            height: 100%;
            justify-content: center;
            align-items: center;
            flex-direction: column;
          }
          .rb_content_model:last-child {
            margin-right: 0px;
          }
          .rb_content_model {
            margin-right: 20px;
            width: 220px;
            height: 247px;
            display: flex;
            flex-direction: column;
            box-sizing: border-box;
            transition: all 0.2s;
            border-radius: 6px;
            justify-content: center;
            align-items: center;
            // 最近浏览模块的上部分
            .rb_content_model_top {
              transition: all 0.2s;
              width: 210px;
              height: 163px;
              /*border: 1px solid #ebeef5;*/
              /*box-sizing: border-box;*/
              border-radius: 6px;
              overflow: hidden;
              img {
                width: 100%;
                height: 100%;
              }
            }
            // 最近浏览模块的下部分
            .rb_content_model_bottom {
              width: 100%;
              height: 30%;
              font-size: 12px;
              color: #606266;
              display: flex;
              justify-content: center;
              flex-direction: column;
            }
            .model_bottom_top {
              padding: 0 10px;
              box-sizing: border-box;
              font-size: 14px;
              font-weight: bold;
              color: #4b5062;
              width: 100%;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .model_bottom_below {
              padding: 0 10px;
              box-sizing: border-box;
              font-size: 14px;
              color: #4b5062;
              width: 100%;
              overflow: hidden;
              white-space: nowrap;
              margin-top: 14px;
              /*text-overflow: ellipsis;*/
              /*display: flex;*/
              /*justify-content: space-between;*/
              /*.bottom_below_left {*/
              /*  padding-left: 10px;*/
              /*}*/
              /*.bottom_below_right {*/
              /*  padding-right: 10px;*/
              /*}*/
            }
          }
        }
        .browse_title_wrap {
          position: relative;
          padding: 20px 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .title_wrap_left {
            font-size: 18px;
            font-weight: bold;
            color: #4b5062;
          }
          .title_wrap_right {
            .more-link {
              color: #4b5062;
              font-size: 14px;
            }
          }
        }
      }
    }
    // 主要内容右侧end

    /* 覆盖element样式start */
    // 订单详情这行的居中对齐
    /*.el-table td,*/
    /*.el-table th {*/
    /*  text-align: center;*/
    /*}*/
    // 最近收藏离左边的距离
    .el-tabs__nav {
      margin-left: 30px;
    }
    // 最近收藏的字体颜色
    .el-tabs__item.is-active {
      color: #000;
      font-size: 16px;
      font-weight: 700;
    }
    // 最近收藏的下边框颜色
    .el-tabs__active-bar {
      background-color: #ff9800;
    }
    // 头部按钮的样式
    .el-button--warning {
      color: #fff;
      background-color: #ff9800;
      border-color: #ff9800;
    }
    /* 覆盖element样式end */
    .flex_left {
      display: flex;
      padding-top: 15px;
    }
    .el-table th {
      background: #f5f6fa;
    }
  }
</style>
